import React from "react";
import { X as XIcon } from "lucide-react";
import { Button } from "../../../../components/UI/Button";

interface ResubmissionDialogProps {
  isOpen: boolean;
  message: string;
  onMessageChange: (message: string) => void;
  onClose: () => void;
  onConfirm: () => void;
}

export const ResubmissionDialog: React.FC<ResubmissionDialogProps> = ({
  isOpen,
  message,
  onMessageChange,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-[0.625rem] max-w-md w-full p-6 m-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">수정 요청</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <XIcon className="w-6 h-6" />
          </button>
        </div>

        <div className="space-y-4">
          <div>
            <label
              htmlFor="resubmission-message"
              className="block text-sm font-medium mb-2 text-left"
            >
              수정 요청 사항
            </label>
            <textarea
              id="resubmission-message"
              placeholder="수정이 필요한 내용을 입력하세요 (최대 200자)"
              value={message}
              onChange={(e) => onMessageChange(e.target.value)}
              maxLength={200}
              rows={4}
              className="w-full px-3 py-2 border border-gray-300 rounded-md resize-none"
            />
            <p className="text-[12px] text-[#757575] mt-1 text-right">
              {message.length} / 200자
            </p>
          </div>
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <Button variant="outline" onClick={onClose}>
            취소
          </Button>
          <Button
            onClick={onConfirm}
            className="bg-[#5c9cff] hover:bg-[#4285f4] text-white"
          >
            수정 요청
          </Button>
        </div>
      </div>
    </div>
  );
};
